import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/dist/quasar.css'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import Layout from '../vue/shared/Layout.vue'
import { Dialog, LoadingBar, Notify, Quasar } from 'quasar'
import Vue_routes from '../modules/vue_routes'
import * as Routes from '../packs/routes'

const quasarOptions = { plugins: { Dialog, Notify, LoadingBar } }
const Pinia = createPinia()
Pinia.use(piniaPluginPersistedstate)

const app = createApp(Layout)
app.use(Quasar, quasarOptions).use(Vue_routes).use(Pinia)

app.config.globalProperties.$routes = Routes

app.mount('#app')
